import { ComponentType } from 'react';

import { InstallDocumentTypes, ModelOutputDocument } from 'types';

export interface DocumentRendererProps {
  modelOutput: ModelOutputDocument;
  accountId: string;
  panelIndex: number;
  isOpen: boolean;
  onToggle: () => void;
  onRefresh?: () => void;
}

type DocumentRenderer = ComponentType<DocumentRendererProps>;

class DocumentRendererRegistry {
  private renderers = new Map<InstallDocumentTypes, DocumentRenderer>();

  register(documentType: InstallDocumentTypes, renderer: DocumentRenderer): void {
    this.renderers.set(documentType, renderer);
  }

  getRenderer(documentType: InstallDocumentTypes): DocumentRenderer | undefined {
    return this.renderers.get(documentType);
  }

  hasRenderer(documentType: InstallDocumentTypes): boolean {
    return this.renderers.has(documentType);
  }
}

export const documentRendererRegistry = new DocumentRendererRegistry();
